'use client';

import { styled } from 'styled-components';

const Link = styled.a`
  display: flex;
  justify-content: space-between;

  color: var(--navbar-toggle-accent-color, #700);
  background: var(--navbar-toggle-accent-background, #fff0f0);
  padding: 16px 16px;
  border: none;

  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  text-decoration: none;

  border-radius: 8px;

  cursor: pointer;

  &:hover {
    color: var(--navbar-toggle-accent-color, #700);
    background-color: var(--navbar-toggle-accent-background-hover, #ffdfdf);

    // Override for open pages
    border-bottom: 0;
  }

  &:focus-visible {
    outline-offset: 2px;
    outline: 2px solid var(--navbar-toggle-color, #fff);
  }
`;

export default Link;
